import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"

import BillingTopUp from "@/components/Common/BillingTopUp"

type Props = {
  notificationType: "warning" | "alert"
  notificationText: string
  notificationButton: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardAlertNotification',
  props: {
    notificationType: null,
    notificationText: null,
    notificationButton: { default: "hidden" }
  },
  setup(__props: any) {

const { notificationType, notificationText, notificationButton } = __props as { notificationType: "warning" | "alert", notificationText: string, notificationButton: string };



const topUpModalIsVisible = ref<boolean>(false)

return { __sfc: true,notificationType, notificationText, notificationButton, topUpModalIsVisible, BillingTopUp }
}

})